<template>
  <div id="app">
    <NavigationHeader />
    <LoadingHeart v-if="loading"/>
    <div class="content" >
        <router-view/>
        <div id="pageFooter">
          <PageFooter />
        </div>
    </div>
  </div>
</template>

<script>
import NavigationHeader from './components/NavigationHeader'
import LoadingHeart from './components/LoadingHeart'
import PageFooter from './components/PageFooter'
import { mapState } from 'vuex'

export default {
  name: 'App',
  components: {
    LoadingHeart,
    NavigationHeader,
    PageFooter
  },
  computed: mapState({
    loading: state => state.loading
  }),
  data() {
    return {
      menu: true,
      navClass: 'top-nav'
    }
  },
  methods: {
    checkUrl() {
      const hash = location.hash
      const selectRoute = (route) => this.$router.push(route)

      if (hash.indexOf('home') !== -1) selectRoute('/')
      else if (hash.indexOf('faq') !== -1) selectRoute('faq')
      else if (hash.indexOf('about') !== -1) selectRoute('faq')
      else if (hash.indexOf('fourPillars') !== -1) selectRoute('fourPillars')
      else if (hash.indexOf('getInvolved') !== -1) selectRoute('getInvolved')
      else if (hash.indexOf('resources') !== -1) selectRoute('resources')
      else if (hash.indexOf('blog') !== -1)selectRoute('blog')
      else if (hash.indexOf('chapters') !== -1) selectRoute('chapters')
      else if (hash.indexOf('news') !== -1) selectRoute('news')
      else if (hash.indexOf('contact') !== -1) selectRoute('contact')
      else if (hash.indexOf('posts') !== -1) selectRoute('posts')
      else if (hash.indexOf('covid') !== -1) selectRoute('covid')
    }
  },
  mounted() {
    this.checkUrl()
  }
}
</script>

<style lang="scss">

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: $primary-dark-color;
  max-width: 1200px;
  min-width: 319px;
  min-height: 1000px;
  margin: 0 auto;
  padding: 0px;
  background-color: white;
  box-shadow: black 2px 6px 6px 6px;
}

.content {
  min-width: 319px;
  margin-top: 22px;
  max-width: 900px;
  min-height: 1200px;
  margin: 22px auto;
  ul { list-style-type: disc; padding: 0; text-align: left;}
  li { margin: 0 10px; }
  a { color: $primary-link-color; font-weight: bold;}

  padding: 15px 15px 100px 15px;

  .latestInfoToc {
      float: right;
      width: 200px;
      margin-left: 40px;
  }

  .latestInfoToc ul {
    list-style-type: disc;
    margin: 0 7px 20px -20px;
    font-size: 12px;
  }

  .latestInfoToc ul li {
      margin-top: 10px;
  }

  .latestInfoEntry {
      margin-bottom: 5px;
      margin-top: 10px;
  }
  p {
    text-align: justify;
  }
}

@media screen and (max-width: 412px) {
  #app {
    padding: 0px;
    margin: 0px;
    box-shadow: white 0px 0px 0px 0px;
  }
  .content {
    padding: 10px 10px 50px 10px;
    margin: 0px auto;
  }
}
</style>
